import { html } from '@nrk/dh-server-libs/html'
import { nrkClose } from '@nrk/core-icons'
import CoreToggle from '@nrk/core-toggle'

export class OrdforklaringTooltip extends HTMLElement {
  connectedCallback() {
    const childNodes = [...this.childNodes]
    const begrep = this.getAttribute('begrep') || this.innerText
    const forklaring = this.getAttribute('forklaring')
    if (!forklaring) {
      return
    }
    /* core toggle does not support shadow dom */
    const elm = document.createElement('div')
    elm.innerHTML = html`<button type="button"></button>
      <core-toggle hidden autoposition data-popup>
        <h3>${begrep}</h3>
        ${forklaring}
        <button type="button" aria-label="Lukk ordforklaring">${nrkClose}</button>
      </core-toggle>`
    const button = elm.querySelector('button')
    button.append(...childNodes)
    this.replaceChildren(...elm.childNodes)

    this.closeButton.addEventListener('click', this.handleClose)
  }

  handleClose = () => {
    this.toggleElement.setAttribute('hidden', '')
  }

  get toggleElement() {
    return this.querySelector('core-toggle')
  }

  get closeButton() {
    return this.querySelector('core-toggle button')
  }
}

/**
 * Patched CoreToggle
 *
 * Makes sure element is not placed outside the viewport on the left side.
 */
export class OrdforklaringToggle extends CoreToggle {
  updatePosition() {
    if (this._skipPosition || !this.button) return

    this.style.position = 'fixed'

    /* Fetch bounding client rects before calling super to avoid layout thrashing */
    const triggerRect = this.button.getBoundingClientRect()
    const contentRect = this.getBoundingClientRect()

    super.updatePosition()

    /* Center element under trigger button */
    const centeredLeft = triggerRect.left + triggerRect.width / 2 - contentRect.width / 2

    this.style.left = `0`
    this.style.left = `clamp(var(--_mobile-padding, 0px), ${centeredLeft}px, calc(${window.innerWidth}px - 300px - var(--_mobile-padding, 0px)))`
    this.style.right = `var(--_mobile-padding, 0px)`
  }
}
